import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'kt-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent {
  @Input() control: FormControl;
  @Input() isRadio: boolean;
  @Input() label: string;
  @Input() iconLabel: string;
  @Input() color: 'primary' | 'secondary' | 'tertiary' | 'neutral' | 'legacy' = 'neutral';
  @Input() value: any;
}
